module.exports = __webpack_public_path__ + "static/media/rendezvous.862db927.jpg";